export class Cell {
  constructor(x, y) {
    this.x = x;
    this.y = y;
    this.valueNum = undefined;
  }
}

module.exports = Cell;
